import { machineLocal } from '~/data/local';

import { SyncQueueRow } from './syncQueueTypes';

function parseQueueData(data: string): Record<string, unknown> {
  try {
    return JSON.parse(data) as Record<string, unknown>;
  } catch {
    return {};
  }
}

function nonEmptyString(value: unknown): string | undefined {
  if (value == null) {
    return undefined;
  }
  const trimmed = String(value).trim();
  return trimmed.length ? trimmed : undefined;
}

export function machineInternFromQueueData(data: string): string | undefined {
  const parsed = parseQueueData(data);
  return nonEmptyString(parsed.machineIntern) ?? nonEmptyString(parsed.intern);
}

async function resolveMachineIntern(
  parsed: Record<string, unknown>,
  internFromPayload: string | undefined,
  internByMachineId: Map<string, string | undefined>
): Promise<string | undefined> {
  if (internFromPayload) {
    return internFromPayload;
  }
  const machineId = parsed.machineId;
  if (machineId == null || machineId === '') {
    return undefined;
  }
  const key = String(machineId);
  if (internByMachineId.has(key)) {
    return internByMachineId.get(key);
  }
  const machine = await machineLocal.machineDetails(key);
  const intern = nonEmptyString(machine?.intern);
  internByMachineId.set(key, intern);
  return intern;
}

/** Machine intern for sync progress labels (queue JSON + local machine lookup). */
export async function machineInternForQueueRow(
  row: SyncQueueRow,
  internByMachineId: Map<string, string | undefined>
): Promise<string | undefined> {
  const parsed = parseQueueData(row.data);
  const fromPayload = machineInternFromQueueData(row.data);
  return resolveMachineIntern(parsed, fromPayload, internByMachineId);
}
